import { render, staticRenderFns } from "./Instruktur.vue?vue&type=template&id=73ea8ed8&"
import script from "./Instruktur.vue?vue&type=script&lang=js&"
export * from "./Instruktur.vue?vue&type=script&lang=js&"
import style0 from "./Instruktur.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports